import { create } from 'zustand';

/* ==========================================================================
   Estado aberto/fechado da gaveta do Vapt IA (change customer-agent-settings,
   design D25)

   Sai do `VaptAiLauncher` para uma store para que outra tela abra a gaveta
   com uma mensagem sugerida ("Resolver com o Vapt IA" na página Atendente
   IA). A mensagem entra no compositor como texto editável, só se ele estiver
   vazio, e nunca é enviada sem o dono tocar em enviar. Quem mostra o atalho
   confere antes a disponibilidade (`useVaptAiAvailable`), a mesma do
   launcher.
   ========================================================================== */

/** Uma mensagem sugerida; o `nonce` distingue dois pedidos com o mesmo texto. */
export interface VaptAiSuggestion {
  text: string;
  nonce: number;
}

export interface VaptAiOpenOptions {
  suggestedText?: string;
}

interface VaptAiLauncherState {
  isOpen: boolean;
  /** Montada na primeira abertura e nunca desmontada (a conversa sobrevive a fechar). */
  everOpened: boolean;
  /** A sugestão ainda não aplicada pelo compositor. */
  suggestion: VaptAiSuggestion | null;
  open: (options?: VaptAiOpenOptions) => void;
  close: () => void;
  toggle: () => void;
  /** O compositor aplicou (ou descartou, por ter rascunho) a sugestão. */
  consumeSuggestion: (nonce: number) => void;
}

let nonce = 0;

export const useVaptAiLauncherStore = create<VaptAiLauncherState>((set) => ({
  isOpen: false,
  everOpened: false,
  suggestion: null,
  open: (options) => {
    const text = options?.suggestedText?.trim();
    if (text) nonce += 1;
    set((state) => ({
      isOpen: true,
      everOpened: true,
      suggestion: text ? { text, nonce } : state.suggestion,
    }));
  },
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen, everOpened: true })),
  consumeSuggestion: (applied) =>
    set((state) => (state.suggestion?.nonce === applied ? { suggestion: null } : state)),
}));

/** Volta ao estado de quem nunca abriu a gaveta (testes e troca de sessão). */
export function resetVaptAiLauncherStore(): void {
  useVaptAiLauncherStore.setState({ isOpen: false, everOpened: false, suggestion: null });
}
